(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["art-print"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('art-print-carousel')) {
    customElements.define(
      'art-print-carousel',
      class ArtPrintCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          if (!this.track) return;

          this.dots = this.querySelector('[data-dots]');
          this.arrows = this.querySelector('[data-arrows]');
          this.prevButton = this.querySelector('[data-prev]');
          this.nextButton = this.querySelector('[data-next]');
          this.labelTemplate = this.dataset.goToLabel || '[number]';
          this.frame = null;

          this.onScroll = () => {
            if (this.frame) return;
            this.frame = requestAnimationFrame(() => {
              this.frame = null;
              this.update();
            });
          };
          this.track.addEventListener('scroll', this.onScroll, { passive: true });

          this.resizeObserver = new ResizeObserver(() => this.update());
          this.resizeObserver.observe(this.track);

          const fragment = document.createDocumentFragment();
          Array.from(this.track.children).forEach((_, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'art-print__dot';
            dot.dataset.index = index;
            dot.setAttribute('aria-label', this.labelTemplate.replace('[number]', index + 1));
            fragment.appendChild(dot);
          });
          this.dots.replaceChildren(fragment);
          this.dots.addEventListener('click', (event) => {
            const dot = event.target.closest('[data-index]');
            if (dot) this.goTo(Number(dot.dataset.index));
          });

          this.prevButton.addEventListener('click', () => this.goTo(this.current() - 1));
          this.nextButton.addEventListener('click', () => this.goTo(this.current() + 1));

          this.update();
        }

        disconnectedCallback() {
          if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.frame) cancelAnimationFrame(this.frame);
        }

        // One slide fills the track, so the index is just the scroll position in slide widths.
        current() {
          const width = this.track.clientWidth || 1;
          return Math.round(this.track.scrollLeft / width);
        }

        goTo(index) {
          const count = this.track.children.length;
          const target = Math.max(0, Math.min(count - 1, index));
          this.track.scrollTo({ left: target * this.track.clientWidth, behavior: 'smooth' });
        }

        update() {
          const count = this.track.children.length;
          const multiple = count > 1;
          const active = this.current();

          this.dots.hidden = !multiple;
          this.arrows.hidden = !multiple;
          if (!multiple) return;

          this.prevButton.disabled = active <= 0;
          this.nextButton.disabled = active >= count - 1;
          this.dots.querySelectorAll('[data-index]').forEach((dot, index) => {
            if (index === active) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  if (!window.__cartPageRefreshBound) {
    window.__cartPageRefreshBound = true;

    // Re-fetches this section's own markup and swaps it in whenever something
    // elsewhere on the page (an add-on card's "Add to cart") changes the cart,
    // so the line items, subtotal, and the checkout-blocked/upsells state all
    // stay correct without a full page reload. Re-rendering server side, via
    // the Section Rendering API, means this doesn't have to duplicate any of
    // this file's own Liquid logic in JavaScript.
    document.addEventListener('cart:updated', async () => {
      const current = document.querySelector('[data-cart-page]');
      if (!current || !current.dataset.sectionId) return;

      current.setAttribute('aria-busy', 'true');

      try {
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', current.dataset.sectionId);

        const response = await fetch(url, { headers: { Accept: 'text/html' } });
        if (!response.ok) return;

        const html = await response.text();
        const updated = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-page]');
        if (updated) current.replaceWith(updated);
      } catch (error) {
        // Network problem: leave the page as-is. The header bag count and the
        // add-on's own "Added" state already reflect the change; a reload
        // picks up the rest.
        current.removeAttribute('aria-busy');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-nav')) {
    customElements.define(
      'faq-nav',
      class FaqNav extends HTMLElement {
        connectedCallback() {
          this.list = this.querySelector('.faq-nav__list');
          this.wrapper = this.closest('.shopify-section') || this;
          this.targets = [];
          this.current = null;

          this.onScroll = () => {
            if (this.frame) return;
            this.frame = requestAnimationFrame(() => {
              this.frame = null;
              this.update();
            });
          };
          // In the theme editor, FAQ sections re-render when blocks change, so rebuild the links.
          this.onEditorChange = () => requestAnimationFrame(() => this.build());

          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll);
          for (const type of ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder']) {
            document.addEventListener(type, this.onEditorChange);
          }

          this.resizeObserver = new ResizeObserver(() => this.setHeight());
          this.resizeObserver.observe(this.wrapper);

          this.build();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
          for (const type of ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder']) {
            document.removeEventListener(type, this.onEditorChange);
          }
          this.resizeObserver.disconnect();
          if (this.frame) cancelAnimationFrame(this.frame);
          document.documentElement.style.removeProperty('--faq-nav-height');
        }

        get sticky() {
          return this.hasAttribute('data-sticky');
        }

        get offset() {
          return this.sticky ? this.wrapper.offsetHeight : 0;
        }

        build() {
          this.targets = [...document.querySelectorAll('.faq-category[id][data-faq-nav-label]')];
          this.list.replaceChildren(
            ...this.targets.map((target) => {
              const item = document.createElement('li');
              const link = document.createElement('a');
              link.className = 'faq-nav__link';
              link.href = `#${target.id}`;
              link.textContent = target.dataset.faqNavLabel;
              item.append(link);
              return item;
            })
          );
          this.current = null;
          this.setHeight();
          this.update();
        }

        setHeight() {
          // Category headers read this as their scroll-margin, so jumps land below the bar.
          document.documentElement.style.setProperty('--faq-nav-height', `${this.offset}px`);
        }

        update() {
          const threshold = this.offset + 40;
          let current = null;
          for (const target of this.targets) {
            if (target.getBoundingClientRect().top > threshold) break;
            current = target;
          }

          if (current !== this.current) {
            this.current = current;
            let activeLink = null;
            this.list.querySelectorAll('.faq-nav__link').forEach((link, index) => {
              const active = this.targets[index] === current;
              link.setAttribute('aria-current', active ? 'true' : 'false');
              if (active) activeLink = link;
            });
            // Scroll the row itself, not the page (scrollIntoView would interrupt a smooth jump).
            if (activeLink) {
              this.list.scrollTo({
                left: activeLink.offsetLeft - (this.list.clientWidth - activeLink.offsetWidth) / 2,
                behavior: 'smooth',
              });
            }
          }

          const lists = document.querySelectorAll('.faq__list');
          const last = lists[lists.length - 1];
          const pastEnd = this.sticky && last && last.getBoundingClientRect().bottom < this.offset;
          this.toggleAttribute('data-past-end', Boolean(pastEnd));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-accordion')) {
    customElements.define(
      'faq-accordion',
      class FaqAccordion extends HTMLElement {
        connectedCallback() {
          // 'toggle' doesn't bubble, so listen in the capture phase.
          this.addEventListener(
            'toggle',
            (event) => {
              if (!this.hasAttribute('data-single-open')) return;
              const opened = event.target;
              if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;
              this.querySelectorAll('details[open]').forEach((entry) => {
                if (entry !== opened) entry.open = false;
              });
            },
            true
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["games-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('games-carousel')) {
    customElements.define(
      'games-carousel',
      class GamesCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          if (!this.track) return;

          this.dotsContainer = this.querySelector('[data-dots]');
          this.arrows = this.querySelector('[data-arrows]');
          this.prevButton = this.querySelector('[data-prev]');
          this.nextButton = this.querySelector('[data-next]');
          this.labelTemplate = this.dataset.goToLabel || '[number]';
          this.frame = null;

          // A clicked dot stays highlighted until the visitor scrolls by hand. Without this,
          // dots for cards that can't reach the left edge (the last few) would all snap to the final dot.
          this.pinned = null;
          this.releasePin = () => {
            this.pinned = null;
          };
          ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach((type) =>
            this.track.addEventListener(type, this.releasePin, { passive: true })
          );

          this.onScroll = () => {
            if (this.frame) return;
            this.frame = requestAnimationFrame(() => {
              this.frame = null;
              this.update();
            });
          };
          this.track.addEventListener('scroll', this.onScroll, { passive: true });

          this.resizeObserver = new ResizeObserver(() => this.update());
          this.resizeObserver.observe(this.track);

          if (this.dotsContainer) {
            this.buildDots();
            this.dotsContainer.addEventListener('click', (event) => {
              const dot = event.target.closest('[data-index]');
              if (!dot) return;
              const card = this.track.children[Number(dot.dataset.index)];
              if (card) {
                this.pinned = Number(dot.dataset.index);
                this.update();
                this.track.scrollTo({ left: card.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
              }
            });
          }

          if (this.prevButton) this.prevButton.addEventListener('click', () => this.step(-1));
          if (this.nextButton) this.nextButton.addEventListener('click', () => this.step(1));

          this.update();
        }

        disconnectedCallback() {
          if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.frame) cancelAnimationFrame(this.frame);
        }

        // Moves by one card (plus the gap) in the given direction.
        step(direction) {
          const card = this.track.children[0];
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          this.pinned = null;
          this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
        }

        buildDots() {
          const fragment = document.createDocumentFragment();
          Array.from(this.track.children).forEach((_, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'games-carousel__dot';
            dot.dataset.index = index;
            dot.setAttribute('aria-label', this.labelTemplate.replace('[number]', index + 1));
            fragment.appendChild(dot);
          });
          this.dotsContainer.replaceChildren(fragment);
        }

        update() {
          const { scrollLeft, scrollWidth, clientWidth } = this.track;
          const cards = Array.from(this.track.children);
          const overflows = scrollWidth - clientWidth > 2;
          const atStart = scrollLeft <= 2;
          const atEnd = scrollLeft + clientWidth >= scrollWidth - 2;

          // Arrows and dots are pointless when every card is already visible.
          if (this.arrows) {
            this.arrows.hidden = !overflows;
            this.prevButton.disabled = atStart;
            this.nextButton.disabled = atEnd;
          }

          if (!this.dotsContainer) return;
          this.dotsContainer.hidden = !overflows || cards.length < 2;
          if (this.dotsContainer.hidden) return;

          const trackStart = this.track.offsetLeft;
          let active = cards.findIndex((card) => card.offsetLeft - trackStart >= scrollLeft - 2);
          if (active === -1) active = cards.length - 1;
          if (atEnd) active = cards.length - 1;
          if (this.pinned !== null) active = this.pinned;

          this.dotsContainer.querySelectorAll('[data-index]').forEach((dot, index) => {
            if (index === active) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Keeps the bag count current when something is added to the cart without a page reload.
  document.addEventListener('cart:updated', (event) => {
    const cart = event.detail && event.detail.cart;
    if (!cart) return;
    document.querySelectorAll('[data-bag-link]').forEach((link) => {
      link.textContent = link.dataset.bagLabel.replace('[count]', cart.item_count);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ticker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ticker-strip')) {
    customElements.define(
      'ticker-strip',
      class TickerStrip extends HTMLElement {
        connectedCallback() {
          this.group = this.querySelector('.ticker__group');
          if (!this.group) return;

          // Speed is set in pixels per second, so the duration depends on how
          // wide one group of text is. Recalculate when that width changes.
          this.observer = new ResizeObserver(() => this.updateDuration());
          this.observer.observe(this.group);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        updateDuration() {
          const speed = Number(this.dataset.speed) || 60;
          const seconds = this.group.offsetWidth / speed;
          if (seconds > 0) this.style.setProperty('--ticker-duration', `${seconds}s`);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
